import { SCALE } from "@/lib/questions";

export function ScaleInput({ questionId, value, onChange, label }) {
  const isSelected = (id) =>
    value === id || (id === "prefer_not" && value === "prefer_not");

  return (
    <div className="cc-card p-5" data-testid={`scale-${questionId}`}>
      <p className="text-base font-medium mb-4 text-[hsl(var(--texto))]">{label}</p>
      <div className="grid grid-cols-4 gap-2 mb-2">
        {SCALE.filter((s) => s.id !== "prefer_not").map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => onChange(s.id)}
            data-selected={isSelected(s.id)}
            data-testid={`scale-${questionId}-${s.id}`}
            className={`rounded-xl border-2 py-3 px-2 text-center transition-all
              ${
                isSelected(s.id)
                  ? "border-[hsl(var(--olivo))] bg-[hsl(var(--olivo))] text-white"
                  : "border-[hsl(33_25%_86%)] bg-white text-[hsl(var(--texto))] hover:border-[hsl(var(--olivo))]/50"
              }`}
            aria-pressed={isSelected(s.id)}
          >
            <div className="font-serif text-lg font-semibold">{s.short}</div>
            <div className="text-xs font-medium mt-1">{s.label}</div>
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={() => onChange("prefer_not")}
        data-selected={isSelected("prefer_not")}
        data-testid={`scale-${questionId}-prefer_not`}
        className={`w-full mt-2 rounded-xl border-2 py-2.5 text-sm font-medium transition-all
          ${
            isSelected("prefer_not")
              ? "border-[hsl(var(--olivo))] bg-[hsl(var(--olivo))]/10 text-[hsl(var(--olivo))]"
              : "border-[hsl(33_25%_86%)] bg-white text-[hsl(var(--muted-foreground))] hover:border-[hsl(var(--olivo))]/50"
          }`}
        aria-pressed={isSelected("prefer_not")}
      >
        Prefiero no responder
      </button>
    </div>
  );
}
